import { render, staticRenderFns } from "./ScrumVision.vue?vue&type=template&id=f9945b26&scoped=true&"
import script from "./ScrumVision.vue?vue&type=script&lang=js&"
export * from "./ScrumVision.vue?vue&type=script&lang=js&"
import style0 from "./ScrumVision.vue?vue&type=style&index=0&id=f9945b26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9945b26",
  null
  
)

export default component.exports